import { Component, input, signal, computed, output, inject, ChangeDetectionStrategy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-paginacion',
  standalone: true,
  templateUrl: './paginacion.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './paginacion.css',
})
export class Paginacion {
  constructor() {
    // Observa los cambios de tamaño para ajustar la vista móvil
    this.breakpoint.observe([Breakpoints.Handset]).subscribe((result) => {
      this.isMobile = result.matches;
    });
  }
  // servicios
  breakpoint = inject(BreakpointObserver);
  // datos
  isMobile = false;
  items = input.required<any[]>();
  itemsPorPagina = input<number>(10);
  totalItems = input<number>(0);
  paginaActual = signal(1);
  paginaCambiada = output<number>();

  // total de pagina es el total de items dividido por itemsPorPagina
  totalPaginas = computed(() => {
    const total = this.totalItems() > 0 ? this.totalItems() : this.items().length;
    const porPagina = this.itemsPorPagina() > 0 ? this.itemsPorPagina() : 1;
    if (total === 0) return 1;
    return Math.max(1, Math.ceil(total / porPagina));
  });

  itemsPaginados = computed(() => {
    // Si los items vienen del backend, ya están paginados
    return this.items();
  });

  cambiarPagina(nueva: number) {
    if (nueva >= 1 && nueva <= this.totalPaginas()) {
      this.paginaActual.set(nueva);
      this.paginaCambiada.emit(nueva);
    }
  }

  // Devuelve un array de páginas y cortes '...'
  paginasVisibles() {
    const total = this.totalPaginas();
    const actual = this.paginaActual();
    const maxBotones = this.isMobile ? 3 : 7; // Responsive: menos botones en móvil
    if (total <= maxBotones) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    const paginas: (number | string)[] = [];
    const mostrarAlrededor = Math.floor((maxBotones - 3) / 2); // 3 = primero, último, y al menos un corte
    let inicio = Math.max(2, actual - mostrarAlrededor);
    let fin = Math.min(total - 1, actual + mostrarAlrededor);
    if (actual - 1 <= mostrarAlrededor) {
      fin = 1 + (maxBotones - 2);
    }
    if (total - actual <= mostrarAlrededor) {
      inicio = total - (maxBotones - 2);
    }
    paginas.push(1);
    if (inicio > 2) paginas.push('...');
    for (let i = inicio; i <= fin; i++) {
      paginas.push(i);
    }
    if (fin < total - 1) paginas.push('...');
    paginas.push(total);
    return paginas;
  }
}
